import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { VERIZON_CLIENT_ID } from '@nsc/clients/server/client-id.js';
import { WorkflowState } from '@nsc/ticket-worker/entities/WorkflowState.js';
import { hasNexusPermission } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { startOfMonth, subMonths } from 'date-fns';

export const subscribeVerizonTicketsWorkedCount = registerQuery({
  operationName: 'subscribeVerizonTicketsWorkedCount',
  type: () => [Int],
  resolve: () => async () => {
    if (!(await hasNexusPermission(NexusPermission.ClientStats))) {
      return [0, 0];
    }

    const col = await getRawCollection(WorkflowState._collectionName);

    const now = new Date();
    const startCurrentMonth = startOfMonth(now);
    const startPreviousMonth = startOfMonth(subMonths(now, 1));

    const baseFilter = {
      clientId: VERIZON_CLIENT_ID,
      ticketID: { $ne: null, $nin: [''] },
    };

    const [currentMonthIDs, previousMonthIDs] = await Promise.all([
      col.distinct('ticketID', {
        ...baseFilter,
        createdAt: { $gte: startCurrentMonth },
      }),
      col.distinct('ticketID', {
        ...baseFilter,
        createdAt: { $gte: startPreviousMonth, $lt: startCurrentMonth },
      }),
    ]);

    return [currentMonthIDs?.length ?? 0, previousMonthIDs?.length ?? 0];
  },
});
